import { Navigate, useLocation } from "react-router-dom";
import { isTokenValid, getLoggedInUserRole } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!isTokenValid(token)) {
    localStorage.removeItem("token");
    return <Navigate to="/auth" replace />;
  }

  const role = getLoggedInUserRole();

  const allowedForAuditor = ["/invoices", "/logout"];
  if (role === "auditor" && !allowedForAuditor.includes(location.pathname)) {
    return <Navigate to="/invoices" replace />;
  }

  return children;
};

export default ProtectedRoute;